import { render, staticRenderFns } from "./EditProfileModal.vue?vue&type=template&id=8bf9bc50&"
import script from "./EditProfileModal.vue?vue&type=script&lang=js&"
export * from "./EditProfileModal.vue?vue&type=script&lang=js&"
import style0 from "./EditProfileModal.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports